import { ApiCore } from "."
import { UserPropertyI } from "./types"

export default new class {
    get(property: string) {
        return ApiCore.getJson<UserPropertyI>('user_properties', { property })
    }

    set(property: string, propertyValue: string) {
        return ApiCore.postJson<UserPropertyI>('user_properties', {
            property, property_value: propertyValue
        })
    }
}